import config from "../../../../config/config";
import { apiCall } from "../../../../_services/apiCall";

export const getUnits = async () => {
    try {
        const { isSuccess, data } = await apiCall(
            `${config.POSTLOGIN_API_URL_COMPANY}getUnitMaster`,
            {},
            {},
            "GET",
            true,
            false
        );

        if (isSuccess) {
            return data || [];
        }

        return [];
    } catch (error) {
        console.error("Error fetching units:", error);
        return [];
    }
};